export default __webpack_public_path__ + "static/media/18t.03a5aff7.jpg";